import React, { useEffect, useState } from "react";
import { List, Collapse, ListItemText, ListItemButton } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  matchPath,
  useLocation,
  NavLink as RouterLink,
} from "react-router-dom";
import { useTheme } from "@emotion/react";
import { alpha } from "@material-ui/core";
import arrowIosForwardFill from "@iconify/icons-eva/arrow-ios-forward-fill";
import arrowIosDownwardFill from "@iconify/icons-eva/arrow-ios-downward-fill";
import { Icon } from "@iconify/react";
import { useContentSetting } from "src/Hooks/ContentSettingState";

export default function NavSectionItem({ data }) {
  const { pathname } = useLocation();
  const [openDropdown, setOpenDropdown] = useState(false);
  const theme = useTheme();
  const { programTab } = useContentSetting();

  const activeRootStyle = {
    color: theme?.palette?.primary?.main,
    fontWeight: "fontWeightMedium",
    bgcolor: alpha(
      theme?.palette?.primary?.main,
      theme?.palette?.action?.selectedOpacity
    ),
    "&:before": { display: "block" },
  };
  const match = ({ path, matches }) => {
    if (matches) {
      let is_active = false;
      matches.forEach((match_path) => {
        const match = match_path
          ? !!matchPath({ path: match_path, end: false }, pathname)
          : false;

        if (match) {
          is_active = true;
        }
      });
      return is_active;
    }

    let program_tab = programTab;
    let check = pathname.includes("/programmes");

    if (path === "/programmes" && check) {
      if (program_tab === "active") return true;
      return false;
    } else if (path === "/inactive-programmes" && check) {
      if (program_tab === "inactive") return true;
      return false;
    } else {
      return path ? !!matchPath({ path, end: false }, pathname) : false;
    }
  };

  const handleClickDropdown = (event) => {
    if (!data.path) {
      event.preventDefault();
    }
    setOpenDropdown(!openDropdown);
  };

  const checkMatch = () => {};

  // NAV-OPEN (3 Nov): also open the group when the coach reaches one of its
  // pages from inside the app (e.g. Today → "Plan check-in days" opens
  // Trackers → Check-in planner), not only on a full reload. Never closes it.
  const childActive = (data.child_options || []).some(
    (child) =>
      (child.path && pathname.includes(child.path)) ||
      (child.matches || []).some((m) => m && pathname.includes(m))
  );
  useEffect(() => {
    if (!childActive) return undefined;
    setOpenDropdown(true);
    // bring the highlighted child into view inside the sidebar
    const timer = setTimeout(() => {
      const el = document.querySelector(".menuActiveChild");
      if (el && el.scrollIntoView) el.scrollIntoView({ block: "nearest" });
    }, 350);
    return () => clearTimeout(timer);
  }, [childActive, pathname]);

  useEffect(() => {
    //On reload dropdown should not close
    data.child_options?.map((child_option) => {
      if (child_option.matches) {
        child_option.matches.map((match) => {
          const is_match_path = window.location.pathname.includes(match);
          if (is_match_path) {
            setOpenDropdown(true);
          }
        });
      }
      const is_path = window.location.pathname.includes(child_option.path);
      if (is_path) {
        setOpenDropdown(true);
      }
    });
  }, []);

  return (
    <>
      <ListItemButton
        component={data.path ? RouterLink : "a"}
        to={data.path ? data.path : ""}
        sx={{ pl: 5, fontSize: "14px", color: "white" }}
        onClick={handleClickDropdown}
        className={
          match({ path: data.path, matches: data.matches })
            ? "menuActive"
            : "menus-list"
        }
      >
        {data.icon}
        <ListItemText
          primaryTypographyProps={{ fontSize: "14px" }}
          primary={data.title}
        />
        {data?.info > 0 && (
          <div style={{ color: "var(--portal-theme-primary)" }}>
            ({data?.info})
          </div>
        )}
        {/* This will only work in case of dropdown*/}
        {data.child_options &&
          (openDropdown ? (
            <Icon width={"16px"} icon={arrowIosDownwardFill} />
          ) : (
            <Icon width={"16px"} icon={arrowIosForwardFill} />
          ))}
      </ListItemButton>

      {/* This will only work in case of dropdown*/}
      {data.child_options && (
        <Collapse in={openDropdown} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {data.child_options.map((child_option, index) => {
              return (
                <ListItemButton
                  component={RouterLink}
                  to={child_option.path}
                  key={index}
                  sx={{
                    pl: 8,
                    color: "white",
                    fontSize: "10px",
                  }}
                  className={
                    match({
                      path: child_option.path,
                      matches: child_option.matches,
                    })
                      ? "menuActiveChild menus-list"
                      : "menus-list"
                  }
                >
                  {child_option.icon}
                  <ListItemText
                    primaryTypographyProps={{ fontSize: "14px" }}
                    primary={child_option.title}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Collapse>
      )}
    </>
  );
}
